import { useEffect } from 'react';
import { subscribeToFavoriteRows } from '../../context/favoritesRealtime';

interface UseFavoriteRowsRealtimeOptions {
  authorId?: number;
  refreshFavorites: () => Promise<void>;
}

const useFavoriteRowsRealtime = ({
  authorId,
  refreshFavorites,
}: UseFavoriteRowsRealtimeOptions): void => {
  useEffect(() => {
    let isCancelled = false;
    let cleanup: (() => void) | null = null;

    const assignCleanup = (nextCleanup: (() => void) | null) => {
      if (isCancelled || !nextCleanup) {
        return;
      }

      cleanup = nextCleanup;
    };

    const cleanupSubscription = () => {
      isCancelled = true;
      if (cleanup) {
        cleanup();
      }
    };

    if (!authorId) {
      return cleanupSubscription;
    }

    const initializeFavoriteRowsSubscription = async () => {
      try {
        assignCleanup(await subscribeToFavoriteRows({
          authorId,
          refreshFavorites,
        }));
      } catch (error) {
        console.error('Failed to subscribe to favorite rows:', error);
      }
    };

    void initializeFavoriteRowsSubscription();

    return cleanupSubscription;
  }, [authorId, refreshFavorites]);
};

export default useFavoriteRowsRealtime;
